/* eslint-disable functional/immutable-data */
import React from "react"
import { Box, Divider, Grid, IconButton, List, ListItem, ListItemText, ListSubheader, Paper, Typography } from "@mui/material"
import { useLang } from "~/hooks/useLang"
import type { CrewList } from "../../interfaces";
import { none, useHookstate, type State } from "@hookstate/core";
import DeleteIcon from '@mui/icons-material/Delete';
import { sortedCrew } from "~/features/Device/components/DeviceInfoDialog";
interface CompositionListProps {
  readonly crewList: State<CrewList[]>;
}

export default function CompositionList({ crewList }: CompositionListProps) {
  const { translate } = useLang();
  const sortedCrewList = sortedCrew(JSON.parse(JSON.stringify(crewList.get())))
  
  const handleRemoveCrewMember = ({crewMemberId, positionName}) => {
    const indexToRemove = Number(sortedCrewList?.findIndex(member => member?.id === crewMemberId && member?.position?.name === positionName));
    if (indexToRemove !== -1) {
      crewList[indexToRemove].set(none);
    }
  };

  return (
    <Grid item xs={6}>
      <Paper elevation={0} variant='outlined' sx={{ height: '300px', overflowY: 'auto' }}>
        <List
          component="nav"
          aria-labelledby="nested-list-type-subtype"
          dense
          subheader={
            <>
              <ListSubheader component="div" id="nested-list-subheader">
                {translate('Crew')}
              </ListSubheader>
              <Divider />
            </>
          }
          sx={{ width: '100%', bgcolor: 'background.paper' }}
        >
          {
            sortedCrewList?.map((crewMember) => {
              return (
                <ListItem key={crewMember?.id} alignItems="flex-start">
                  <ListItemText
                    primary={translate(crewMember?.position?.name)}
                    secondary={
                      <Box width={'100%'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                        <Typography
                          component="span"
                          variant="body2"
                          sx={{ color: 'text.primary', display: 'inline' }}
                        >
                          {`${crewMember?.registration ? `[${crewMember?.registration}] ${crewMember.representationName}` : crewMember?.representationName}`}
                        </Typography>
                        <IconButton onClick={() => handleRemoveCrewMember({crewMemberId: crewMember?.id, positionName: crewMember?.position?.name})} size="small" >
                          <DeleteIcon />
                        </IconButton>
                      </Box>
                    }
                  />
                </ListItem>
              )
            }
          )}
        </List>
      </Paper>
    </Grid>
  )
}